<smt-workflow-header [costCenter]="costCenter"></smt-workflow-header>

<div class="content-inner" [class.loading]="loading">
  <div class="workflow-section-heading">Select a Shift Block</div>
  <div class="form-group">
    <label for="block-date">Select a Date</label>
    <input type="date" [value]="date" (change)="updateDate($event.target.value)">
  </div>

  <div class="display-label">Shift Blocks for {{ dateDescription }} </div>
  <ul class="button-list" [class.loading]="!loading && listLoading">
    <li *ngFor="let shiftBlock of list">
      <a class="button" [routerLink]="routerLink()" [queryParams]="queryParams(shiftBlock)">
        {{format(shiftBlock)}}    <span [class]="getBlockStatusIcon(shiftBlock)"></span>
      </a>
    </li>
  </ul>
</div>
